import React from "react";
import { TILES } from "./dispatchRules";

/** Fly / Non fly tiles: the Duty type filter (1 = fly, 2 = non fly). */
const DUTY_TILES = [
  { id: 1, key: "fly", label: "fly", icon: "fas fa-plane" },
  { id: 2, key: "nonFly", label: "non fly", icon: "fas fa-building" },
];

/**
 * Counters of the loaded rides: Rides (clears every filter: all rides), Fly / Non fly (the Duty type filter), then
 * Pending / On job / Completed / Cancelled and Clubbed — a click shows only those rides (click again to show all); they combine.
 */
export default function DispatchSummary({ count, tile, onTile, dutyCount, duty, onDuty, clubCount, club, onClub, total, allShown, onAll }) {
  return (
    <section className="hcf-summary dsp-summary" aria-label="Summary">
      <div className="hcf-summary__info">
        <button
          type="button"
          className={`hcf-counter hcf-counter--action dsp-tile${allShown ? " is-selected" : ""}`}
          aria-pressed={allShown}
          title="Show all rides"
          onClick={onAll}
        >
          <i className="fas fa-car" aria-hidden="true" />
          <strong>{total}</strong>
          <span>all rides</span>
          <i className="fas fa-chevron-right hcf-counter__go" aria-hidden="true" />
        </button>
        {DUTY_TILES.map((d) => (
          <button
            key={d.id}
            type="button"
            className={`hcf-counter hcf-counter--action dsp-tile${duty === d.id ? " is-selected" : ""}`}
            aria-pressed={duty === d.id}
            title={duty === d.id ? "Show all rides" : `Show ${d.label} rides`}
            onClick={() => onDuty(duty === d.id ? 0 : d.id)}
          >
            <i className={d.icon} aria-hidden="true" />
            <strong>{dutyCount[d.key]}</strong>
            <span>{d.label}</span>
            <i className="fas fa-chevron-right hcf-counter__go" aria-hidden="true" />
          </button>
        ))}
      </div>
      <div className="hcf-summary__actions">
        {TILES.map((t) => (
          <button
            key={t.id}
            type="button"
            className={`hcf-counter hcf-counter--action dsp-tile is-${t.id}${tile === t.id ? " is-selected" : ""}`}
            aria-pressed={tile === t.id}
            title={tile === t.id ? "Show all rides" : `Show ${t.label.toLowerCase()} rides`}
            onClick={() => onTile(tile === t.id ? "" : t.id)}
          >
            <i className={t.icon} aria-hidden="true" />
            <strong>{count[t.id]}</strong>
            <span>{t.label.toLowerCase()}</span>
            <i className="fas fa-chevron-right hcf-counter__go" aria-hidden="true" />
          </button>
        ))}
        <button
          type="button"
          className={`hcf-counter hcf-counter--action dsp-tile${club ? " is-selected" : ""}`}
          aria-pressed={club}
          title={club ? "Show all rides" : "Show clubbed rides"}
          onClick={() => onClub(!club)}
        >
          <i className="fas fa-link" aria-hidden="true" />
          <strong>{clubCount}</strong>
          <span>clubbed</span>
          <i className="fas fa-chevron-right hcf-counter__go" aria-hidden="true" />
        </button>
      </div>
    </section>
  );
}
